import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Typography,
  Input,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  message,
  Table,
  Radio,
  Popconfirm,
} from "antd";
import moment from "moment";
import { platformApi } from "../../../../../api";
import { getUUID } from "../../../../../_helpers/utils";
import { set } from "lodash";
const { Title, Text } = Typography;
const { Option } = Select;
const MaterialForm = (props) => {
  const {
    form,
    id,
    jobNo,
    setJobNo,
    partsData,
    setPartsData,
    mechanic,
    setMechanic,
    editData,
    setEditData,
    editable,
    setEditable,
    onEdit,
    modifyType,
    initialData,
    setInitialData,
    isCEO,
    modifyAccess,
  } = props;

  const issueTypes = [
    { key: "Foc", title: "FOC" },
    { key: "Paid", title: "PAID" },
    { key: "warranty", title: "WARRANTY" },
  ];
  const getPartItemData = () => ({
    id: getUUID(),
    partNumber: {},
    issueType: "PAID",
    mechanic: "",
    issueDate: moment(Date.now()),
    quantity: "",
    sourceBinLocations: [],
    sourceBinLocation: [],
    mrp: "",
    slipNumber: currentSlipNo + 1,  // 🔧 Set from current slip number
    grandTotal: 0,
    remove: "",
  });

  const getEffectiveBinStock = (b, record) => {
    const bName = (b.binNum || b.binLocation || "").trim();
    let phy = parseInt(b.phyQuantity) || 0;
    if (record && record.initialBinLocations && record.initialBinLocations.includes(bName)) {
      const binShare = (parseFloat(record.initialQuantity) || 0) / (record.initialBinLocations.length || 1);
      phy += binShare;
    }
    return phy;
  };

  const extractActiveBinsForPart = (partNumber, spareInventoryObj, currentSelectedBins = [], record = null) => {
    if (!partNumber || !spareInventoryObj || !spareInventoryObj[partNumber]) return [];
    const inv = spareInventoryObj[partNumber];
    const list = [];
    if (inv && inv.binLocations) {
      try {
        const parsed = typeof inv.binLocations === "string" ? JSON.parse(inv.binLocations) : inv.binLocations;
        if (Array.isArray(parsed)) list.push(...parsed.map(item => ({ ...item })));
      } catch (e) {
        // Ignore JSON parse error for binLocations
      }
    }

    const selected = Array.isArray(currentSelectedBins) ? currentSelectedBins : [];
    const initial = record && Array.isArray(record.initialBinLocations) ? record.initialBinLocations : [];
    const mustInclude = new Set([...selected, ...initial]);

    mustInclude.forEach((bName) => {
      const cleanName = (bName || "").trim();
      if (cleanName) {
        const exists = list.some(
          (b) => (b.binNum || b.binLocation || "").trim().toLowerCase() === cleanName.toLowerCase()
        );
        if (!exists) {
          list.push({ binNum: cleanName, binLocation: cleanName, phyQuantity: 0 });
        }
      }
    });

    return list.filter((b) => {
      const bName = (b.binNum || b.binLocation || "").trim();
      const phy = parseInt(b.phyQuantity) || 0;
      const isMust = Array.from(mustInclude).some(
        (name) => (name || "").trim().toLowerCase() === bName.toLowerCase()
      );
      return phy > 0 || isMust;
    });
  };

  const autoSelectBinsForIssueQty = (activeBins, reqQty, record) => {
    let accumulated = 0;
    const selectedBins = [];
    for (const b of activeBins) {
      if (accumulated >= reqQty) break;
      const bName = (b.binNum || b.binLocation || "").trim();
      const qty = getEffectiveBinStock(b, record);
      if (qty > 0 && bName) {
        selectedBins.push(bName);
        accumulated += qty;
      }
    }
    return { selectedBins, totalQty: accumulated };
  };

  const adjustBinLocationsForQty = (currentSelectedBins, activeBins, reqQty, record) => {
    if (!reqQty || reqQty <= 0) return [];

    let keptBins = [];
    let accumulated = 0;

    if (Array.isArray(currentSelectedBins)) {
      for (const bName of currentSelectedBins) {
        if (accumulated >= reqQty) break;
        const found = activeBins.find((b) => (b.binNum || b.binLocation || "").trim() === bName.trim());
        if (found) {
          const qty = getEffectiveBinStock(found, record);
          if (qty > 0) {
            keptBins.push(bName);
            accumulated += qty;
          }
        }
      }
    }

    if (accumulated < reqQty) {
      for (const b of activeBins) {
        if (accumulated >= reqQty) break;
        const bName = (b.binNum || b.binLocation || "").trim();
        const qty = getEffectiveBinStock(b, record);
        if (qty > 0 && bName && !keptBins.includes(bName)) {
          keptBins.push(bName);
          accumulated += qty;
        }
      }
    }

    return keptBins;
  };

  const handleBinChange = (selectedBinsArray, recordId, activeBins) => {
    setItemList((prevItemList) =>
      prevItemList.map((item) => {
        if (item.id === recordId) {
          const reqQty = parseInt(item.quantity) || 0;
          const prevBins = Array.isArray(item.sourceBinLocations)
            ? item.sourceBinLocations
            : (item.sourceBinLocation ? (typeof item.sourceBinLocation === "string" ? item.sourceBinLocation.split(",").map(s => s.trim()).filter(Boolean) : [item.sourceBinLocation]) : []);

          let finalBins = [];

          if (Array.isArray(selectedBinsArray) && selectedBinsArray.length > 0) {
            const newlyAdded = selectedBinsArray.filter((b) => !prevBins.includes(b));

            // Candidate list: newly added bins first, then remaining selected bins
            const candidateList = [
              ...newlyAdded,
              ...selectedBinsArray.filter((b) => !newlyAdded.includes(b)),
            ];

            let accumulated = 0;
            for (const bName of candidateList) {
              if (accumulated >= reqQty && reqQty > 0) break;
              const found = activeBins.find(
                (b) => (b.binNum || b.binLocation || "").trim() === bName.trim()
              );
              if (found) {
                const stock = getEffectiveBinStock(found, item);
                if (stock > 0) {
                  finalBins.push(bName);
                  accumulated += stock;
                }
              } else {
                finalBins.push(bName);
              }
            }
          }

          return {
            ...item,
            sourceBinLocations: finalBins,
            sourceBinLocation: finalBins.join(","),
          };
        }
        return item;
      })
    );
  };
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const history = useHistory();
  const location = useLocation();
  const [branch, setBranch] = useState("");
  const [itemList, setItemList] = useState([getPartItemData()]);
  const [selectItemObj, setSelectItemObj] = useState({})
  const [customer, setCustomer] = useState("");
  const [mcid, setMcid] = useState("");
  const [grandTtl, setGrandTotal] = useState(0);
  const [quantity, setQuantity] = useState();
  const [mrp, setMrp] = useState();
  const [deleteData, setDeleteData] = useState([]);
  const [deletePartData, setDeletePartData] = useState([]);
  const [pid, setPid] = useState([]);
  const [pBranch, setPBranch] = useState("");
  const [btnFlag, setBtnFlag] = useState(false);
  const [quantityValidation, setQuantityValidation] = useState({})
  const [spareInventory, setSpareInventory] = useState({})
  const [initialPartDetails, setInitialPartDetails] = useState({})
  const [isJobOrderCompleted, setIsJobOrderCompleted] = useState(true)
  const partsRef = {};
  const [totalPartCharge, setTotalPartCharge] = useState(0)
  const [currentSlipNo, setCurrentSlipNo] = useState(0);
  const [showImportButton, setShowImportButton] = useState(false);

  useEffect(() => {
    if (editData && editData.parts) {
      setCurrentSlipNo(editData?.slipNumber)
      setGrandTotal(editData.netAmount ? editData.netAmount : 0);
      const updateItemList = [...editData.parts];
      const extraMechanics = [];   // Mechanic Id - Issue fixed
      if (editData.mechanic) {
        const mechanicId = editData.mechanic.id || editData.mechanic;
        const mechanicObj = typeof editData.mechanic === "object" ? editData.mechanic : { id: mechanicId };
        if (!mechanic.some((m) => m.id === mechanicId) && !extraMechanics.some((m) => m.id === mechanicId)) {
          extraMechanics.push(mechanicObj);
        }
      }
      for (let item of updateItemList) {
        if (item.mechanic) {
          const mId = item.mechanic.id || item.mechanic;
          const mObj = typeof item.mechanic === "object" ? item.mechanic : { id: mId };
          if (!mechanic.some((m) => m.id === mId) && !extraMechanics.some((m) => m.id === mId)) {
            extraMechanics.push(mObj);
          }
        }
      }
      if (extraMechanics.length > 0) {
        setMechanic([...mechanic, ...extraMechanics]);
      }
      const jobStatus = editData.job?.jobStatus === "Proforma Invoice" ? true : false;
      setIsJobOrderCompleted(jobStatus);
      for (let i = 0; i < updateItemList.length; i++) {
        if (
          updateItemList[i].part &&
          !partsData.some(
            (tempItem) => updateItemList[i].part.id === tempItem.id
          )
        ) {
          platformApi
            .get("/api/partsMaster/" + updateItemList[i].part.id)
            .then((res) => {
              let { data } = res;
              if (data && data.code === 200) {
                let { response } = data;
                if (response && response.code === 200) {
                  setPartsData([...partsData, response.data]);
                }
              }
            });
        }
        if (updateItemList[i].part) {
          updateItemList[i].partNumber = updateItemList[i].part;
          updateItemList[i].partNumber.partName = updateItemList[i].partName;
          setMrp(updateItemList[i].part.mrp);
        }
        const savedBins = updateItemList[i].sourceBinLocation
          ? (typeof updateItemList[i].sourceBinLocation === "string"
            ? updateItemList[i].sourceBinLocation.split(",").map((s) => s.trim()).filter(Boolean)
            : Array.isArray(updateItemList[i].sourceBinLocation)
              ? updateItemList[i].sourceBinLocation
              : [updateItemList[i].sourceBinLocation])
          : [];
        updateItemList[i].sourceBinLocations = savedBins;
        updateItemList[i].sourceBinLocation = savedBins;
        updateItemList[i].initialQuantity = parseFloat(updateItemList[i].quantity || 0);
        updateItemList[i].initialBinLocations = [...savedBins];
      }
      setItemList(updateItemList);
      // Always fetch the Job Order to get its authoritative branch.
      // We must NOT use editData.branch.id because the record may have been
      // saved with the wrong branch (e.g., user's login branch instead of job's branch).
      platformApi.get("/api/jobOrder/" + editData.job.id).then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200 && response.data) {
            // Add to jobNo list if not already present
            if (!jobNo.some((tempItem) => editData.job.id === tempItem.id)) {
              setJobNo((prev) => [...prev, response.data]);
            }
            setCurrentSlipNo(response.currentSlipNumber);
            const jobBranchId = response.data.branch?.id;
            const jobBranchName = response.data.branch?.name;
            // Always use the Job Order's branch — never the record's saved branch
            form.setFieldsValue({ branch: jobBranchName });
            setPBranch(jobBranchId);
            setBranch(jobBranchId);
            // This triggers getSpareInventory with the correct (job's) branch
            if (jobBranchId) {
              setJobOrderBranch(jobBranchId);
            }
          }
        }
      });
      let str = `${editData.job.customer && editData.job.customer.name} - ${editData.job.customerPhone
        }`;
      setFieldsValue({
        JobNo: editData.job.id,
        mechanic: editData.mechanic && editData.mechanic.id,
        customer: str,
        registerNo: editData.job.vehicle && editData.job.vehicle.registerNo,
        engineNo: editData.job.vehicle && editData.job.vehicle?.engineNo,
        chassisNo: editData.job.vehicle && editData.job.vehicle?.chassisNo,
        model:
          editData.job.vehicle?.vehicle?.modelName || "",
      });
      setMcid(editData?.mechanic?.id || "");
      for (let item of editData.parts) {
        pid.push(item.id);
      }
      setPid(pid);
    }
  }, [editData]);

  useEffect(() => {
    if (location.state) {
      setFieldsValue({
        JobNo: location.state.jobNo,
      });
      if (!jobNo.some((tempItem) => location.state.jobNo === tempItem.id)) {
        platformApi.get("/api/jobOrder/" + location.state.jobNo).then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setJobNo([...jobNo, response.data]);
              form.setFieldsValue({
                branch: response.data?.branch.name
              })
            }
          }
        });
      }
      fetchJobDetails(location.state.jobNo && location.state.jobNo);
    }
  }, [location.state]);

  const deleteParts = (e) => {
    const deleteSource = itemList.filter((item) => item.id == e);
    if (pid.indexOf(e) >= 0) {
      deleteData.push(e);
    }
    setDeleteData(deleteData);
    for (let i = 0; i < deleteSource.length; i++) {
      deletePartData.push(deleteSource[i]);
    }
    setDeletePartData(deletePartData);
  };

  // Track whether the branch has been resolved from a Job Order (vs the user's default)
  const [jobOrderBranch, setJobOrderBranch] = useState("");

  useEffect(() => {
    // Only fetch the logged-in user's default branch for initial pBranch; do NOT fetch
    // spare inventory yet — inventory must be loaded from the Job Order's branch, not the user's.
    platformApi.get("/api/user/currentUser").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setPBranch(response.data.profile.branch[0].id);
          // NOTE: Do NOT call setBranch here. Branch is set from fetchJobDetails so
          // it always reflects the Job Order's branch, not the user's default.
        }
      }
    });
  }, []);

  const getSpareInventory = (branch, jobCardIdParam) => {
    if (!branch) return; // Never fetch inventory without a valid branch
    const jobCardId = jobCardIdParam || form.getFieldValue("JobNo") || (editData && editData.job && editData.job.id) || (location.state && location.state.jobNo);
    const payload = { branch };
    if (jobCardId) {
      payload.jobCardId = jobCardId;
    }
    platformApi.post("/api/sparesInventory/getAllByBranch", payload).then((res) => {
      const spareObject = {}
      if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
        for (const spare of res.data.response.data) {
          if (spare && spare.partNo) {
            const partNumber = spare.partNo.partNumber
            spareObject[partNumber] = spare
          }
        }
      }
      setSpareInventory(spareObject)
    })
  }

  // Refresh spare inventory whenever the resolved Job Order branch changes
  useEffect(() => {
    if (jobOrderBranch) {
      const jobCardId = form.getFieldValue("JobNo") || (editData && editData.job && editData.job.id) || (location.state && location.state.jobNo);
      getSpareInventory(jobOrderBranch, jobCardId)
    }
  }, [jobOrderBranch])

  useEffect(() => {
    if (initialData?.parts) {
      const partDetails = {}
      for (const part of initialData.parts) {
        if (part && part.part) {
          const partNumber = part.part.partNumber
          partDetails[partNumber] = {
            quantity: part.quantity ? parseFloat(part.quantity) : 0
          }
        }
      }
      setInitialPartDetails(partDetails)
    }
  }, [initialData])

  // useEffect(() => {
  //   if (
  //     itemList &&
  //     itemList?.length > 0 &&
  //     (itemList[itemList?.length - 1].partNumber.partNumber ||
  //       itemList[itemList?.length - 1].quantity?.length > 0)
  //   ) {
  //     handleAdd();
  //   }

  //   const selectItem = {}
  //   let totalCharge=0
  //   for (const item of itemList) {
  //     selectItem[item.partNumber.id] = item.partNumber
  //     if(item.mrp!="") {
  //       totalCharge+=roundOf(item.mrp)*roundOf(item.quantity)
  //     }

  //   }
  //   setTotalPartCharge(roundOf(totalCharge))

  //   setSelectItemObj(selectItem)
  // }, [itemList]);

  useEffect(() => {
    if (
      itemList &&
      itemList.length > 0 &&
      itemList[itemList.length - 1].partNumber &&
      (itemList[itemList.length - 1].partNumber.partNumber ||
        (itemList[itemList.length - 1].quantity && itemList[itemList.length - 1].quantity.length > 0))
    ) {
      handleAdd();
    }

    const selectItem = {};
    let totalCharge = 0;
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        selectItem[item.partNumber.id] = item.partNumber;
      }
      if (item.mrp != "") {
        totalCharge += roundOf(item.mrp) * roundOf(item.quantity);
      }
    }
    setTotalPartCharge(roundOf(totalCharge));
    setSelectItemObj(selectItem);
  }, [itemList]);

  const fetchJobMaterial = (id) => {
    platformApi.get(`/api/materialIssue/jobMaterial/${id}`).then((res) => {
      const responseData = res?.data?.response?.data;

      // Handle array response - take the first (most recent) material issue
      if (responseData && Array.isArray(responseData) && responseData.length > 0) {
        const latestMaterial = responseData[0]; // or you could show a selector if multiple exist
        setEditData(latestMaterial);
        setInitialData(latestMaterial);
        setEditable(true);
      } else {
        // No existing material issue - create new
        setEditData(null);
        setInitialData({});
        setEditable(false);
        setItemList([getPartItemData()]);
        setGrandTotal(0);
      }
    }).catch((error) => {
      console.error('Error fetching job material:', error);
      message.error('Failed to check existing material issue');
    });
  };

  const handleAdd = () => {
    let newArr = [...itemList, getPartItemData()];
    setItemList(newArr);
  };

  const roundOf = (number) => {
    if (number == null) return number;
    const roundedNumber = parseFloat(number).toFixed(2);
    return parseFloat(roundedNumber);
  };

  const renderColumns = () => {
    const columns = [
      {
        title: "S.No",
        dataIndex: "sno",
        key: "sno",
        width: 51,
        render: (text, record, index) => index + 1,
      },
      {
        title: "PartNumber",
        dataIndex: "partNumber",
        key: "partNumber",
        width: 420,
        render: (record, data, key) => (
          <Form.Item>
            <Select
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              onFocus={event => {
                setQuantityValidation(prev => ({ ...prev, [data.partNumber.partNumber]: false }))
                const search = {
                  module: "sparesInventories",
                  column: "partNumber",
                  searchString: "",
                  searchColumns: ["partNumber", "partName"],
                  setValue: setPartsData,
                };
                searchParts(search);
                if (partsData?.length === 1) {
                  const part = partsData[0];
                  if (!(part.id in selectItemObj) || part.id === data.partNumber?.id) {
                    handlePartDetail(part.id, data);
                    partsRef[key]?.focus();
                  }
                }
              }}

              onChange={(event) => {
                handlePartDetail(event, data);
              }}
              onSearch={async (event) => {
                if (event) {
                  if (event.includes("ocpart") || event.includes("OCPART")) {
                    const newItemList = [...itemList];
                    if (event !== undefined) {
                      const pName = event.split("-")[1];
                      for (let item of newItemList) {
                        if (item.id === data.id) {
                          let data = {
                            id: item.id,
                            partNumber: "OCPART",
                            partName: pName,
                          };
                          item.partNumber = data;
                          item.mrp = 1;
                          item.quantity = 1;
                          setQuantity(1);
                          setMrp(1);
                        }
                      }
                    }
                    setItemList(newItemList);
                    getParts(pBranch || branch);
                  } else {
                    const search = {
                      module: "sparesInventories",
                      column: "partNumber",
                      searchString: event,
                      searchColumns: ["partNumber", "partName"],
                      setValue: setPartsData,
                    };
                    searchParts(search);
                    if (partsData?.length === 1) {
                      const part = partsData[0];
                      if (!(part.id in selectItemObj) || part.id === data.partNumber?.id) {
                        handlePartDetail(part.id, data);
                        partsRef[key]?.focus();
                      }
                    }
                  }
                }
              }}
              value={
                record?.partNumber == undefined
                  ? "Part Number"
                  : `${record.partNumber} - ${record.partName}`
              }
              disabled={editable}
              showSearch
              showAction={["click", "focus"]}
              placeholder="Part Number"
              filterOption={(input, option) =>
                option.props.children.some(
                  (child) =>
                    child && child.toLowerCase().indexOf(input.toLowerCase()) >= 0
                )
              }
            >
              {Array.isArray(partsData) &&
                partsData.map((part) => {
                  if (!part || (part.id in selectItemObj && part.id !== data.partNumber?.id)) return null;
                  return (
                    <Select.Option key={part.id} value={part.id}>
                      {part.partNumber} - {part.partName}
                    </Select.Option>
                  )
                })}
            </Select>
          </Form.Item>
        ),
      },
      {
        title: "Issue Type",
        dataIndex: "issueType",
        key: "issueType",
        width: 125,
        render: (data, record) => (
          <Form.Item>
            <Select
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              onChange={(event) => {
                handleTypehange(event, record);
              }}
              showSearch
              disabled={editable}
              placeholder="Issue Type"
              value={record && record.issueType ? record.issueType : "PAID"}
            >
              {issueTypes.map((issue) => (
                <Select.Option key={issue.key} value={issue.title}>
                  {issue.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        ),
      },
      {
        title: "Issue Date",
        dataIndex: "issueDate",
        key: "issueDate",
        width: 90,
        render: (record) => (
          <span>
            {record
              ? moment(record).format("DD-MM-YYYY")
              : moment(Date.now()).format("DD/MM/YYYY")}
          </span>
        ),
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 100,
        render: (data, record, index) => {
          const partNumber = record.partNumber?.partNumber;
          let maxQty = null;
          if (partNumber) {
            const inv = spareInventory[partNumber];
            const inventoryQty = inv != null
              ? (inv.availableForJob !== undefined ? inv.availableForJob : inv.phyQuantity)
              : 0;
            const prevPart = initialPartDetails[partNumber];
            maxQty = prevPart
              ? inventoryQty + parseFloat(prevPart.quantity || 0)
              : inventoryQty;
          }
          return (
            <Form.Item
              validateStatus={`${(partNumber && quantityValidation[partNumber]) ? "error" : "success"}`}
              help={partNumber && quantityValidation[partNumber]}
            >
              <Input
                key="quantity"
                disabled={editable}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9]/g, ""); // only digits
                  handleQuantity({ target: { value } }, record);
                }}
                ref={(el) => (partsRef[index] = el)}
                placeholder="Qty"
                value={record && record.quantity}
                addonAfter={
                  maxQty != null
                    ? <span style={{ color: '#888', fontSize: 12 }}>/{maxQty}</span>
                    : null
                }
              />
            </Form.Item>
          );
        },
      },
      {
        title: "MRP",
        dataIndex: "mrp",
        key: "mrp",
        width: 100,
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="mrp"
              disabled={editable}
              onChange={(event) => {
                const value = event.target.value.replace(/[^0-9.]/g, ""); // digits and dot
                // Ensure only one dot
                const parts = value.split(".");
                const cleanedValue = parts[0] + (parts.length > 1 ? "." + parts[1] : "");
                handleMRP({ target: { value: cleanedValue } }, record);
              }}
              placeholder="Mrp"
              value={record && record.mrp}
            />
          </Form.Item>
        ),
      },
      {
        title: "Slip No",
        dataIndex: "slipNo",
        key: "slipNo",
        width: 60,
        render: (data, record, index) => <span>{record.slipNumber ? record.slipNumber : currentSlipNo + 1}</span>,
      },
      {
        title: "Bin Location",
        dataIndex: "sourceBinLocations",
        key: "sourceBinLocations",
        width: 220,
        render: (data, record) => {
          const partNumber = record.partNumber?.partNumber;

          let currentVal = [];
          if (Array.isArray(record.sourceBinLocations)) {
            currentVal = record.sourceBinLocations;
          } else if (record.sourceBinLocation) {
            currentVal = typeof record.sourceBinLocation === "string"
              ? record.sourceBinLocation.split(",").map((s) => s.trim()).filter(Boolean)
              : [record.sourceBinLocation];
          }

          const activeBins = extractActiveBinsForPart(partNumber, spareInventory, currentVal, record);
          const reqQty = parseInt(record.quantity) || 0;

          if (currentVal.length === 0 && activeBins.length > 0 && reqQty > 0) {
            const auto = autoSelectBinsForIssueQty(activeBins, reqQty, record);
            currentVal = auto.selectedBins;
          }

          const selectedStockSum = (currentVal || []).reduce((sum, bName) => {
            const found = activeBins.find(
              (b) => (b.binNum || b.binLocation || "").trim() === bName.trim()
            );
            return sum + (found ? getEffectiveBinStock(found, record) : 0);
          }, 0);

          const isStockSatisfied = reqQty > 0 && selectedStockSum >= reqQty;
          const isMissingBin = reqQty > 0 && currentVal.length === 0;

          return (
            <Form.Item
              validateStatus={isMissingBin ? "error" : undefined}
              help={isMissingBin ? "Bin Location required" : null}
            >
              <Select
                mode="multiple"
                disabled={editable || !partNumber}
                placeholder="Bin Location"
                value={currentVal}
                onChange={(selectedBinsArray) => {
                  handleBinChange(selectedBinsArray, record.id, activeBins);
                }}
                tagRender={(tagProps) => {
                  const { label, closable, onClose } = tagProps;
                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        background: "#f5f5f5",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        padding: "2px 8px",
                        marginRight: "4px",
                        marginBottom: "2px",
                        fontSize: "12px",
                        color: "rgba(0, 0, 0, 0.75)",
                        fontWeight: 500,
                      }}
                    >
                      {label}
                      {closable && !editable && (
                        <span
                          onClick={onClose}
                          style={{
                            marginLeft: "6px",
                            cursor: "pointer",
                            fontWeight: "bold",
                            color: "#ff4d4f",
                          }}
                        >
                          ×
                        </span>
                      )}
                    </span>
                  );
                }}
                dropdownStyle={{ maxHeight: 200, overflowY: "auto" }}
                style={{ width: "100%", overflowX: "auto" }}
              >
                {activeBins.map((b) => {
                  const bName = b.binNum || b.binLocation;
                  const bStock = getEffectiveBinStock(b, record);
                  const isDisabled = bStock <= 0;
                  return (
                    <Select.Option key={bName} value={bName} disabled={isDisabled}>
                      {bName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          );
        },
      },
      {
        title: "Action",
        dataIndex: "remove",
        key: "x",
        width: 70,
        render: (data, record) => (
          <Form.Item>
            {itemList.length >= 1 ? (
              editable ? null : (
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => {
                    handleDelete(record.id);
                  }}
                >
                  <a style={{ color: "#6c7b8a" }}>Delete</a>
                </Popconfirm>
              )
            ) : null}
          </Form.Item>
        ),
      },
    ];
    return columns;
  };
  //Handle Delete
  const handleDelete = (selectedId) => {
    const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
    let grandTotal = 0;
    for (let i = 0; i < updatedDataSource.length; i++) {
      if (
        updatedDataSource[i].mrp > 0 &&
        parseFloat(updatedDataSource[i].quantity) > 0
      ) {
        let total = (
          parseFloat(updatedDataSource[i].quantity) *
          parseFloat(updatedDataSource[i].mrp)
        ).toFixed(2);
        updatedDataSource[i].grandTotal = parseFloat(total);
      }
    }
    for (let i = 0; i < updatedDataSource.length; i++) {
      grandTotal =
        parseFloat(grandTotal) + parseFloat(updatedDataSource[i].grandTotal);
      grandTotal = grandTotal.toFixed(2);
    }
    setItemList(updatedDataSource);
    deleteParts(selectedId);
  };
  //Handle Quantity
  const checkPartQuantity = (quantity, partNumber) => {
    const inv = spareInventory[partNumber];
    const availableQty = inv != null ? (inv.availableForJob !== undefined ? inv.availableForJob : inv.phyQuantity) : 0;
    if (Number(quantity) > availableQty) {
      setQuantityValidation(prev => ({
        ...prev,
        [partNumber]: `Available ${availableQty}`
      }))
      return false
    }
    setQuantityValidation(prev => ({
      ...prev,
      [partNumber]: false
    }))
    return true
  }


  const handleInventoryForModify = (currentQuantity, partNumber) => {
    if (currentQuantity == null || partNumber == null) return;
    const inventory = spareInventory[partNumber]
    const prevPart = initialPartDetails[partNumber]
    const removeQuantity = currentQuantity - prevPart.quantity
    const availableQty = inventory != null ? (inventory.availableForJob !== undefined ? inventory.availableForJob : inventory.phyQuantity) : 0;
    if (prevPart.quantity >= currentQuantity || availableQty >= removeQuantity) {
      return true
    } else {
      const availableQuantity = availableQty + parseFloat(prevPart.quantity)
      setQuantityValidation(prev => ({
        ...prev,
        [partNumber]: `Available ${availableQuantity}`
      }))
      return false
    }
  }


  const handleInventory = (quantity, partNumber) => {
    if (quantity === "" || partNumber == null || spareInventory[partNumber] == null) return;
    setQuantityValidation(prev => ({ ...prev, [partNumber]: false }))
    if (initialPartDetails[partNumber]) {
      return handleInventoryForModify(Number(quantity), partNumber)
    } else {
      return checkPartQuantity(Number(quantity), partNumber)
    }
  }
  const handleQuantity = (event, record) => {
    const partNumber = record.partNumber?.partNumber;
    let value = event.target.value;

    // Cap the entered quantity at the available physical quantity
    if (partNumber) {
      const inv = spareInventory[partNumber];
      const inventoryQty = inv != null
        ? (inv.availableForJob !== undefined ? inv.availableForJob : inv.phyQuantity)
        : 0;
      const prevPart = initialPartDetails[partNumber];
      const maxQty = prevPart
        ? inventoryQty + parseFloat(prevPart.quantity || 0)
        : inventoryQty;

      if (Number(value) > maxQty) {
        value = String(maxQty);
        message.warning(`Maximum available quantity for this part is ${maxQty}`, 2);
      }
    }

    setQuantity(value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.quantity = value;
        const activeBins = extractActiveBinsForPart(partNumber, spareInventory);
        const reqQty = parseInt(value) || 0;
        if (activeBins.length > 0) {
          const updatedBins = adjustBinLocationsForQty(item.sourceBinLocations || [], activeBins, reqQty);
          item.sourceBinLocations = updatedBins;
          item.sourceBinLocation = updatedBins;
        }
        break;
      }
    }
    setItemList(newItemList);
    handleInventory(value, partNumber);
  };
  //HandleMRP
  const handleMRP = (event, record) => {
    setMrp(event.target.value);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.mrp = event.target.value;
        break;
      }
    }
    setItemList(newItemList);
  };
  //Handle Mechanic
  const handleMechanic = (event) => {
    setMcid(event);
    setFieldsValue({
      mechanic: event,
    });
  };
  const handleTypehange = (event, data) => {
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === data.id) {
        item.issueType = event;
        break;
      }
    }
    setItemList(newItemList);
  };

  const handleMechanicTable = async (event, data) => {
    setItemList((prevItemList) =>
      prevItemList.map((item) =>
        item.id === data.id
          ? {
            ...item,
            mechanic: event,
            slipNumber: item.slipNumber || currentSlipNo + 1,
          }
          : item
      )
    );
  };

  const handlePartDetail = async (event, data) => {
    const newItemList = [...itemList];
    if (event !== undefined) {
      partsData.map((part) => {
        if (part.id === event) {
          for (let item of newItemList) {
            if (item.id === data.id) {
              item.partNumber = part;
              item.mrp = part.mrp;
              item.quantity = 1;
              item.slipNumber = currentSlipNo + 1; // 🔧 Ensure slip number

              const activeBins = extractActiveBinsForPart(part.partNumber, spareInventory);
              if (activeBins.length > 0) {
                const auto = autoSelectBinsForIssueQty(activeBins, 1);
                item.sourceBinLocations = auto.selectedBins;
                item.sourceBinLocation = auto.selectedBins;
              }

              setQuantity(1);
              setMrp(part.mrp);
            }
          }
        }
      });
    }
    setItemList(newItemList);
    getParts(pBranch || branch);
  };
  //Handle Calculation
  useEffect(() => {
    let grandTotal = 0;
    let newItemList = [...itemList];
    for (let i = 0; i < newItemList.length; i++) {
      if (quantity > 0 || mrp > 0) {
        if (newItemList[i].mrp > 0 && parseFloat(newItemList[i].quantity) > 0) {
          let total = (
            parseFloat(newItemList[i].quantity) * parseFloat(newItemList[i].mrp)
          ).toFixed(2);
          newItemList[i].grandTotal = parseFloat(total);
        }
      }
    }
    for (let i = 0; i < newItemList.length; i++) {
      grandTotal =
        parseFloat(grandTotal) + parseFloat(newItemList[i].grandTotal);
      grandTotal = grandTotal.toFixed(2);
    }
    setGrandTotal(grandTotal);
    setItemList(newItemList);
    setQuantity(undefined);
  }, [quantity, mrp]);
  //Handle Submit
  const validateInventory = (itemList) => {
    const keys = itemList.map(item => {
      if (item.partNumber && item.partNumber.partNumber)
        return { quantity: item.quantity, partNumber: item.partNumber.partNumber };
      return null;
    }).filter(item => item != null);
    for (const key of keys) {
      if (handleInventory(key.quantity, key.partNumber) === false) return false;
    }
    return true;
  };

  const handleSubmit = () => {
    // Bug Fix: Ensure the branch has been resolved from the Job Order before submitting.
    // If jobOrderBranch is empty, the user hasn't selected a valid Job Order yet.
    if (!jobOrderBranch && !editData?.branch?.id) {
      message.error("Please select a Job Order first. Branch cannot be determined.");
      return;
    }

    const isValid = validateInventory(itemList);
    if (!isValid) return message.error("Stock Not available in Inventory. Please reduce the quantity.");

    // Bin Location Validation & Auto Resolution
    for (let item of itemList) {
      if (item.partNumber && (item.partNumber.id || item.partNumber.partNumber) && parseInt(item.quantity || 0) > 0) {
        const partNumber = item.partNumber.partNumber;
        let selectedBins = item.sourceBinLocations || [];
        if ((!selectedBins || selectedBins.length === 0) && item.sourceBinLocation) {
          selectedBins = typeof item.sourceBinLocation === "string"
            ? item.sourceBinLocation.split(",").map((s) => s.trim()).filter(Boolean)
            : [item.sourceBinLocation];
        }
        const activeBins = extractActiveBinsForPart(partNumber, spareInventory, selectedBins, item);
        const reqQty = parseInt(item.quantity || 0);

        // Auto-select bins if not already explicitly populated in item state
        if ((!selectedBins || selectedBins.length === 0) && activeBins.length > 0 && reqQty > 0) {
          const auto = autoSelectBinsForIssueQty(activeBins, reqQty, item);
          selectedBins = auto.selectedBins;
          item.sourceBinLocations = selectedBins;
          item.sourceBinLocation = selectedBins.join(",");
        }

        if (activeBins.length > 0) {
          if (!selectedBins || selectedBins.length === 0) {
            return message.error(`Please select Bin Location for part "${partNumber}".`);
          }
          const selectedStockSum = selectedBins.reduce((sum, bName) => {
            const found = activeBins.find((b) => (b.binNum || b.binLocation || "").trim() === bName.trim());
            return sum + (found ? getEffectiveBinStock(found, item) : 0);
          }, 0);
          if (selectedStockSum < reqQty) {
            return message.error(
              `Selected Bin Locations for "${partNumber}" only have ${selectedStockSum} available stock, but ${reqQty} requested.`
            );
          }
        }
      }
    }

    form.validateFields((validationError) => {
      let newItemList = [...itemList];
      if (newItemList.length > 0) {
        newItemList = newItemList
          .filter((item) => item.partNumber && item.quantity)
          .map((item) => {
            const binVal = item.sourceBinLocations || item.sourceBinLocation;
            const sourceBinLocation = Array.isArray(binVal) ? binVal.join(",") : (binVal || "");
            return {
              ...item,
              sourceBinLocation: sourceBinLocation,
            };
          });
      }
      setItemList(newItemList);

      // Use the Job Order's branch (jobOrderBranch) for the submission;
      // fall back to editData.branch.id when editing an existing record.
      const submittedBranch = jobOrderBranch || editData?.branch?.id || branch;

      const data = {
        jobOrder: getFieldValue("JobNo"),
        currentDate: moment(Date.now()),
        vehicle: getFieldValue("registerNo") && getFieldValue("registerNo"),
        model: getFieldValue("model") && getFieldValue("model"),
        engineNo: getFieldValue("engineNo") && getFieldValue("engineNo"),
        chassisNo: getFieldValue("chassisNo") && getFieldValue("chassisNo"),
        customer: customer,
        mechanic: mcid || getFieldValue("mechanic"),
        materialItemInvoice: newItemList,
        slipNumber: currentSlipNo + 1,
        netAmount: grandTtl,
        branch: submittedBranch,
        deleteData: deleteData,
        deletePartData: deletePartData,
      };
      if (validationError === null) {
        setBtnFlag(true);
        if (editData && editData?.id) {
          platformApi
            .put(`/api/materialIssue/${editData.id}`, data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success("Parts Issue Modified Successfully");
                  history.push("/autoadmin/material_issue");
                }
              }
            })
            .catch((err) => {
              console.error("Material Add Error: ", err);
              const errMsg = err?.response?.data?.message || "Couldn't update Material";
              message.error(errMsg, 5);
            }).finally(() => {
              setBtnFlag(false);
            })
        } else {
          platformApi
            .post("/api/materialIssue/", data)
            .then((result) => {
              let { data } = result;
              if (data.code === 200) {
                let { response } = data;
                if (response.code === 200) {
                  message.success("Parts Issue Added Successfully");
                  history.push("/autoadmin/material_issue");
                }
              }
            })
            .catch((err) => {
              console.error("Material Add Error: ", err);
              const errMsg = err?.response?.data?.message || "Couldn't Add Material";
              message.error(errMsg, 5);
            }).finally(() => {
              setBtnFlag(false);
            })
        }
      } else {
        message.error("select atleast one item list");
      }
    });
  };
  //Handle Cancel
  const handleCancel = () => {
    form.resetFields();
    setItemList([getPartItemData()]);  // 🔧 Use function
    setJobNo([]);
    setPartsData([]);
    setCurrentSlipNo(null);
    setMechanic([]);
    setDeleteData([]);
    setDeletePartData([]);
    history.push("/autoadmin/material_issue");
  };

  const searchJobNo = (value) => {
    const payload = {
      page: 1,
      size: 50,
      searchString: value,
      column: "jobNo",
      module: "jobOrders",
      except: ["Gate Pass", "Payment Received", "Invoice", "Proforma Invoice", "PAID"]
    };
    platformApi
      .post("/api/options/get/", payload)
      .then((res) => {
        setJobNo(res.data.response);
      });
  };

  const searchMechanic = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 100,
        page: 1,
        except: null,
      })
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let mechanic = data.response.filter((item) => {
            return (
              item.profile &&
              item.profile.department.role === "Mechanic" &&
              item.status === true
            );
          });
          search.setValue(mechanic);
        }
      });
  };

  const searchParts = async (search) => {
    const res = await platformApi.post("/api/options/get/", {
      module: search.module,
      column: search.column,
      searchString: search.searchString,
      fields: search.fields,
      size: 100,
      page: 1,
      except: null,
      branch: pBranch,
    });
    let parts = [];
    for (let i = 0; i < res.data.response?.length; i++) {
      const element = res.data.response[i];
      parts.push(element.partNo);
    }
    search.setValue(parts);
    return 1;
  };

  const fetchJobDetails = (value) => {
    if (value) {
      fetchJobMaterial(value);
      setShowImportButton(true);
      setFieldsValue({
        JobNo: value,
      });
      platformApi.get("/api/jobOrder/" + value).then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (response.data) {
              let str = `${response.data.customer && response.data.customer.name
                } - ${response.data.customerPhone && response.data.customerPhone}`;
              const jobStatus = response.data.jobStatus === "Proforma Invoice" ? true : false;
              if (response.data.mechanic) {
                const mechanicId = response.data.mechanic.id || response.data.mechanic;
                const mechanicObj = typeof response.data.mechanic === "object" ? response.data.mechanic : { id: mechanicId };
                if (!mechanic.some((m) => m.id === mechanicId)) {
                  setMechanic([...mechanic, mechanicObj]);
                }
              }
              setIsJobOrderCompleted(jobStatus);
              setFieldsValue({
                registerNo:
                  response.data.vehicle && response.data.vehicle.registerNo,
                engineNo:
                  response.data.vehicle && response.data.vehicle?.engineNo,
                chassisNo:
                  response.data.vehicle && response.data.vehicle?.chassisNo,
                model:
                  response.data.vehicle?.vehicle?.modelName || "",
                customer: str,
                mechanic: response.data.mechanic && response.data.mechanic.id,
                branch: response.data?.branch.name
              });
              const resolvedBranchId = response.data.branch && response.data.branch.id;
              setBranch(resolvedBranchId);
              setJobOrderBranch(resolvedBranchId); // Mark branch as resolved from Job Order
              setMcid(response.data.mechanic && response.data.mechanic.id);
              setCustomer(response.data.customer && response.data.customer.id);
              setPBranch(resolvedBranchId);
              getParts(resolvedBranchId);
            }
          }
        }
      });
    } else {
      setShowImportButton(false);
    }
  };
  //Get Parts
  const getParts = (branch) => {
    platformApi
      .post(`/api/sparesInventory/branch/get`, {
        page: 1,
        size: 100,
        searchString: "",
        ...(branch && { branch: [branch] })
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            let parts = [];
            for (let item of response.data) {
              if (item.phyQuantity > 0) {
                parts.push(item.partNo);
              }
            }
            // setPartsData(response.data.partsMaster);
            setPartsData(parts);
          }
        } else {
          message.error("Unable to fetch Parts", 2);
        }
      });
  };

  const handleImportFromEstimate = async () => {
    const jobOrderNo = getFieldValue('JobNo');
    if (!jobOrderNo) {
      message.error('Please select a job order first');
      return;
    }

    try {
      const response = await platformApi.get(`/api/materialIssue/import-from-estimate/${jobOrderNo}`);
      const { data } = response;

      if (data.code === 200 && data.data) {
        const { availableParts, unavailableParts, totalParts, availableCount } = data.data;

        if (availableParts && availableParts.length > 0) {
          const formattedParts = availableParts.map(part => {
            const partNum = part.partNumber?.partNumber;
            const reqQty = parseInt(part.quantity) || 0;
            const activeBins = extractActiveBinsForPart(partNum, spareInventory, []);
            let autoBins = [];
            if (activeBins.length > 0 && reqQty > 0) {
              const auto = autoSelectBinsForIssueQty(activeBins, reqQty, {});
              autoBins = auto.selectedBins;
            }

            return {
              id: getUUID(),
              partNumber: {
                id: part.partNumber.id,
                partNumber: part.partNumber.partNumber,
                partName: part.partNumber.partName,
                mrp: part.partNumber.mrp,
                ndp: part.partNumber.ndp
              },
              issueType: "PAID",
              mechanic: getFieldValue('mechanic') || "",
              issueDate: moment(Date.now()),
              quantity: part.quantity,
              mrp: part.partNumber.mrp,
              slipNumber: "",
              grandTotal: part.quantity * part.partNumber.mrp,
              sourceBinLocations: autoBins,
              sourceBinLocation: Array.isArray(autoBins) ? autoBins.join(",") : (autoBins || ""),
              remove: ""
            };
          });

          const nonEmptyRows = itemList.filter(item =>
            item.partNumber && item.partNumber.partNumber && item.quantity
          );

          setItemList([...nonEmptyRows, ...formattedParts, getPartItemData()]);  // import estimate issue fixed

          const newTotal = formattedParts.reduce((sum, item) => Number(sum) + Number(item.grandTotal), grandTtl);

          setGrandTotal(newTotal);

          message.success(`Imported ${availableCount} out of ${totalParts} parts from estimate`);

          if (unavailableParts && unavailableParts.length > 0) {
            message.warning(`${unavailableParts.length} parts are not available in inventory`);
          }
        } else {
          message.info('No parts found in the estimate');
        }
      } else if (data.code === 404) {
        message.info(data.message || 'No approved estimate found for this job order');
      } else {
        message.error(data.message || 'Failed to import parts from estimate');
      }
    } catch (error) {
      console.error('Error importing from estimate:', error);
      if (error.response?.data?.code === 'CONTROLLER.QUERY.ERROR') {
        message.error('Unable to fetch estimate data. Please contact support.');
      } else {
        message.error('Failed to import parts from estimate');
      }
    }
  };

  return (
    <div>
      <Form className="material-form" form={form}>
        <Row gutter={[16, 16]} align="middle">
          <Col span={6}>
            <Form.Item
              colon={false}
              className="purchase-form-element"
              label={<Text>Job No</Text>}
            >
              {getFieldDecorator("JobNo", {
                rules: [{ required: true, message: "Please select Job No" }],
              })(
                <Select
                  showSearch
                  placeholder="Select Job No"
                  optionFilterProp="children"
                  onSearch={(e) => {
                    searchJobNo(e);
                  }}
                  onChange={fetchJobDetails}
                  filterOption={false}
                  style={{ width: "100%" }}
                >
                  {jobNo.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.jobNo}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          {showImportButton && (
            <Col span={4} style={{ marginTop: '40px' }}>
              <Button
                type="primary"
                onClick={handleImportFromEstimate}
                style={{ width: '100%' }}
              >
                Import from Estimate
              </Button>
            </Col>
          )}
          <Col span={6}>
            <Form.Item
              colon={false}
              className="purchase-form-element"
              label={<Text>Branch</Text>}
            >
              {getFieldDecorator("branch", {
                rules: [{ required: false, message: "Select Branch" }],
              })(<Input placeholder="Branch" disabled={true} />)}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item colon={false} label="Mechanic">
              {getFieldDecorator("mechanic", {
                rules: [
                  {
                    required: true,
                    message: "Mechanic",
                  },
                ],
              })(
                <Select
                  key="mechanic"
                  showAction={["click", "focus"]}
                  filterOption={null}
                  showSearch
                  placeholder="Mechanic"
                  disabled={editable}
                  onSearch={(e) => {
                    const search = {
                      module: "user",
                      column: "employeeName",
                      searchString: e,
                      searchColumns: ["employeeName"],
                      setValue: setMechanic,
                    };
                    searchMechanic(search);
                  }}
                  onSelect={(event) => {
                    handleMechanic(event);
                  }}
                >
                  {mechanic.length &&
                    mechanic.map((obj) => (
                      <Select.Option key={obj.id} value={obj.id}>
                        {obj.profile && obj.profile.employeeName
                          ? obj.profile.employeeName
                          : obj.profile.employeeId}
                      </Select.Option>
                    ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item colon={false} label="Customer">
              {getFieldDecorator("customer", {
                rules: [
                  {
                    required: false,
                    message: "Customer No",
                  },
                ],
              })(<Input placeholder="Customer." disabled={true} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col span={6}>
            <Form.Item colon={false} label="Vehicle">
              {getFieldDecorator("registerNo", {
                rules: [
                  {
                    required: false,
                    message: "Register No",
                  },
                ],
              })(<Input placeholder="Register No." disabled={true} />)}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item colon={false} label="Model">
              {getFieldDecorator("model", {
                rules: [
                  {
                    required: false,
                    message: "Model Name",
                  },
                ],
              })(<Input placeholder="Model" disabled={true}></Input>)}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item colon={false} label="Engine No">
              {getFieldDecorator("engineNo", {
                rules: [
                  {
                    required: false,
                    message: "Engine No",
                  },
                ],
              })(<Input placeholder="EngineNo." disabled={true} />)}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item colon={false} label="Chassis No">
              {getFieldDecorator("chassisNo", {
                rules: [
                  {
                    required: false,
                    message: "Chassis No",
                  },
                ],
              })(<Input placeholder="ChasisNo." disabled={true} />)}
            </Form.Item>
          </Col>
        </Row>

        <Table
          className="parts-invoice-table"
          childrenColumnName="none"
          rowKey={(record) => record.id}
          columns={renderColumns()}
          dataSource={itemList}
          tableLayout="fixed"
          pagination={false}
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        />
        <br />
        <Row gutter={1} style={{ position: "relative", left: "48rem" }}>
          <Col span={6}>
            <Form.Item
              className="form-element"
              label="Part Charge"
            >
              <Input
                placeholder="Part Charge"
                disabled={true}
                value={totalPartCharge}
              />
            </Form.Item>
          </Col>
        </Row>

        <div style={{ float: "right" }}>
          <Button
            style={{ marginRight: "1rem" }}
            size="large"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button>
          {
            !isJobOrderCompleted && (
              editable ? (
                modifyAccess && (
                  <Button
                    type="primary"
                    size="large"
                    disabled={btnFlag}
                    onClick={() => onEdit(false)}
                  >
                    Modify
                  </Button>
                )
              ) : (
                <Button
                  type="primary"
                  size="large"
                  disabled={btnFlag}
                  onClick={() => handleSubmit()}
                >
                  Save
                </Button>
              )
            )
          }
        </div>
      </Form>
    </div>
  );
};
const WrappedMaterialForm = Form.create()(MaterialForm);

export default WrappedMaterialForm;
